import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../../api"
import type { CustomExteriorColorOptionsView } from "../../common/colors/exteriorColor/CustomExteriorColorOptionsView"

export const getCustomExteriorColorOptionsRoute: ApiRoute<
	NoPathParams,
	NoQueryParams,
	NoBody,
	CustomExteriorColorOptionsView
> = {
	buildUrl: () => "/colors/exterior-color/custom-options",
	method: "get",
	path: "/colors/exterior-color/custom-options",
}
